/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { IoEye } from "react-icons/io5";
import ReactTable from "react-table";

import { formatDate } from "../../helpers/date";

import ResponsiveDataComponent from "../common/ResponsiveDataComponent";
import Badge from "../common/Badge";
import Loading from "../common/Loading";

const AuditLogList = (props) => {
  const {
    isMobile,
    defaultPageSize,
    onPageSizeChange,
    minimal,
    sorted,
    history
  } = props;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (Array.isArray(props.data)) {
      setData(props.data);
      setLoading(false);
    }
  }, [props.data]);

  const columns = !isMobile
    ? [
        {
          Header: "Action",
          accessor: "action",
          maxWidth: 140,
          Cell: (row) => (
            <Badge color={row?.value?.color}>{row?.value?.label}</Badge>
          )
        },
        {
          Header: "Created Date",
          accessor: "created_on",
          maxWidth: 240,
          Cell: ({ value }) => (
            <span>
              {formatDate(value, "MMM dd, yyyy")}
              <br />
              {formatDate(value, "hh:mm a")}
            </span>
          )
        },
        {
          Header: "User",
          accessor: "user",
          maxWidth: 240,
          Cell: (row) => (
            <span>
              {row?.value?.first_name}&nbsp;{row?.value?.last_name}
            </span>
          )
        },
        {
          maxWidth: 240,
          Header: "Action Required By",
          accessor: "actionRequiredBy"
        },
        {
          Header: "Note",
          accessor: "note"
        },
        {
          Header: "",
          accessor: "call",
          maxWidth: 100,
          Cell: (row) =>
            row?.original?.action?.label === "Completed" ? (
              <IoEye onClick={() => history.push(`/app/calls/${row?.value}`)} />
            ) : null
        }
      ]
    : [
        {
          Header: "User",
          accessor: "user.email",
          style: { textAlign: "center" },
          maxWidth: 80
        },
        {
          Header: "Action",
          accessor: "action",
          style: { textAlign: "center" },
          maxWidth: 140,
          Cell: (row) => (
            <Badge color={row?.value?.color}>{row?.value?.label}</Badge>
          )
        }
      ];

  return (
    <ReactTable
      className="-highlight audit"
      data={data}
      columns={columns}
      showPageSizeOptions={!isMobile}
      defaultPageSize={defaultPageSize}
      {...(minimal && {
        pageSize: minimal && data.length < 5 ? data.length + 1 : 5
      })}
      onPageSizeChange={onPageSizeChange}
      LoadingComponent={() => <Loading active={loading} />}
      showPagination={data.length > 5}
      defaultSorted={
        sorted || [
          {
            id: "created_on",
            desc: true
          }
        ]
      }
      SubComponent={
        isMobile
          ? ({ original }) => (
              <ResponsiveDataComponent
                data={[
                  {
                    key: "User",
                    label: original.user.email
                  },
                  { key: "Action", label: original.action.color }
                ]}
              />
            )
          : false
      }
    />
  );
};

AuditLogList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  isMobile: PropTypes.bool,
  onClickView: PropTypes.func,
  defaultPageSize: PropTypes.number,
  onPageSizeChange: PropTypes.func,
  minimal: PropTypes.bool,
  sorted: PropTypes.array,
  history: PropTypes.object
};

export default AuditLogList;
